export enum LeadPriorityScore {
    High = "high",
    Medium = "medium",
    Low = "low",
    Unlock = "unlock",
    NoScore = "noScore",
}

export const SCORING_PRIORITIES: readonly LeadPriorityScore[] = [
    LeadPriorityScore.High,
    LeadPriorityScore.Medium,
    LeadPriorityScore.Low,
];

export type TriggeredRule = {
    readonly ruleId: string;
    readonly score: LeadPriorityScore.High | LeadPriorityScore.Medium | LeadPriorityScore.Low;
};

export type LeadPriorityValue = {
    readonly score: LeadPriorityScore;
    readonly triggeredRules: readonly TriggeredRule[];
};
